import modalSureSelConfirm from './view/modalSureSelConfirm.html'
import modalCancelSuccess from './view/modalCancelSuccess.html'
import modalConfirmSuccess from './view/modalConfirmSuccess.html'
import modalSureSelConCtrl from './modalSureSelConCtrl'
import modalCancelSuccessCtrl from './modalCancelSuccessCtrl'
import modalConfirmConCtrl from './modalConfirmConCtrl'

import drawBackPage from './view/drawBack.html'

export default function drawBack(
  $uibModal,
  httpRequest,
  logger,
  modalSelConDetailService,
  operationService,
  $timeout,
  Upload
) {
  return {
    restrict: 'E',
    scope: {
      active: '@',
    },
    template: drawBackPage,
    link(scope) {
      if (
        !operationService.hasPermit('drawback_info') &&
        !operationService.hasPermit('confirm_drawback_info')
      ) {
        return
      }
      scope.importBtnCollapsed = false
      scope.activeTab = `${scope.active}`
      scope.selectedRows = []
      scope.selStatus = 'noSel'
      scope.profileType = scope.activeTab == '1' ? '144' : '145'
      const typeCode = scope.activeTab == '1' ? 'DRAWBACK_CHECK' : ''
      scope.param = {
        pageNum: null,
        pageSize: null,
        param: {
          authStatus: '255',
          invoiceMaxDate: '',
          invoiceMinDate: '',
          invoiceCode: '',
          invoiceNumber: '',
          invoiceStatus: '0',
          // invoiceType: '',
          managerStatus: '1',
          checkStatus: scope.activeTab == '1' ? '0' : '10',
          checkFlag: '1',
        },
      }
      // 设置日期组件时间
      // function setDateTime(res) {
      //     const periodCode = res.data.value.periodCode
      //     const periodYear = periodCode[0] + periodCode[1] + periodCode[2] + periodCode[3]
      //     const periodMonth = periodCode[4] + periodCode[5]
      //     scope.param.param.invoiceMinDate = `${periodYear}-${periodMonth}-` + '01'
      //     const isLeap = (periodYear % 4 === 0) && (periodYear % 100 === 0) || (periodYear % 400 === 0)
      //     const monthArr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
      //     if (isLeap) {
      //         monthArr[1] = 29
      //     }
      //     scope.param.param.invoiceMaxDate = `${periodYear}-${periodMonth}-${monthArr[periodMonth - 1]}`
      // }
      function getAmt() {
        httpRequest.get_ivatDrawbackCheck_getHeaderData().then((res) => {
          scope.hadAmount = res.data.value.hadAmount
          scope.hadTaxAmt = res.data.value.hadTaxAmt
          scope.hadCheckNotConfirmAmt = res.data.value.hadCheckNotConfirmAmt
          scope.hadCheckNotConfirmTaxAmt =
            res.data.value.hadCheckNotConfirmTaxAmt
          scope.notHadCheckAmt = res.data.value.notHadCheckAmt
          scope.notHadCheckTaxAmt = res.data.value.notHadCheckTaxAmt
          scope.overTaxPeriod = res.data.value.overTaxPeriod
        })
      }
      function qrySelecInfo() {
        httpRequest
          .post_ivatDrawbackCheck_qryInvoiceCheckOfPage(scope.param)
          .then((res) => {
            if (res.data.success) {
              scope.selecInfoList = res.data.value.list
              scope.selectedRows = []
              // 获取后台分页数据 回写分页组件
              scope.totalItems = res.data.value.total
              scope.param.pageNum = ++res.data.value.prePage
              scope.param.pageSize = res.data.value.pageSize
            }
          })
        getAmt()
      }

      const invListLabelConfigTmp =
        scope.activeTab == '1'
          ? {
              version: 1.01,
              invListLabel: [
                {
                  label: '开票日期',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票代码',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票号码',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票状态',
                  selected: false,
                  default: false,
                },
                {
                  //     label: '发票种类',
                  //     selected: false,
                  //     default: false,
                  // }, {
                  label: '管理状态',
                  selected: false,
                  default: false,
                },
              ],
              table: [
                {
                  label: '发票代码',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票号码',
                  selected: true,
                  default: true,
                },
                {
                  label: '开票日期',
                  selected: true,
                  default: true,
                },
                {
                  label: '销方名称',
                  selected: true,
                  default: true,
                },
                {
                  label: '金额',
                  selected: true,
                  default: true,
                },
                {
                  label: '税额',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票状态',
                  selected: true,
                  default: true,
                },
                {
                  label: '是否勾选',
                  selected: true,
                  default: true,
                },
                {
                  label: '勾选时间',
                  selected: true,
                  default: true,
                },
                {
                  label: '管理状态',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票种类',
                  selected: true,
                  default: true,
                },
                {
                  label: '收票状态',
                  selected: true,
                  default: true,
                },
                {
                  label: '是否确认',
                  selected: true,
                  default: true,
                },
                {
                  label: '确认时间',
                  selected: true,
                  default: true,
                },
              ],
            }
          : {
              version: 1.01,
              invListLabel: [
                {
                  label: '开票日期',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票代码',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票号码',
                  selected: true,
                  default: true,
                },
              ],
              table: [
                {
                  label: '发票代码',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票号码',
                  selected: true,
                  default: true,
                },
                {
                  label: '开票日期',
                  selected: true,
                  default: true,
                },
                {
                  label: '销方名称',
                  selected: true,
                  default: true,
                },
                {
                  label: '金额',
                  selected: true,
                  default: true,
                },
                {
                  label: '税额',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票状态',
                  selected: true,
                  default: true,
                },
                {
                  label: '勾选时间',
                  selected: true,
                  default: true,
                },
                {
                  label: '管理状态',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票种类',
                  selected: true,
                  default: true,
                },
                {
                  label: '收票状态',
                  selected: true,
                  default: true,
                },
              ],
            }
      // 搜索字段,字段设置
      scope.invListLabelConfig = invListLabelConfigTmp

      // 发票类型过滤
      const typecodeArr = [
        'ivat_orig_inv_type',
        'auth_type',
        'ivat_invoice_status',
        'check_status',
        'deduction_check_type',
        'ivat_inv_receive_status',
        'drawback_check_type',
        'label_auth_type',
        'manager_status',
        'is_received',
        'info_source',
        'check_type_status',
        'drawback_auth_status',
      ]
      scope.dictionary = {
        YES_NO: [
          {
            enumName: '否',
            enumCode: '0',
          },
          {
            enumName: '是',
            enumCode: '1',
          },
        ],
      }
      httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
        scope.dictData = scope.dictionary = $.extend(
          scope.dictionary,
          res.data.value
        )
      })
      scope.orderMap = {
        sortKey: '',
        sortVal: '',
      }
      // 未勾选|已勾选tab
      scope.tabChange = function tabChange(v) {
        scope.selStatus = v
        if (scope.selStatus == 'noSel') {
          scope.param.param.checkStatus = scope.activeTab == '1' ? '0' : '10'
          scope.param.param.authStatus = '255'
        } else {
          scope.param.param.checkStatus = '10'
          scope.param.param.authStatus = scope.activeTab == '1' ? '0,255' : '0'
        }
        qrySelecInfo()
      }

      scope.reset = function () {
        scope.param = {
          pageNum: null,
          pageSize: null,
          param: {
            authStatus: '255',
            invoiceMaxDate: '',
            invoiceMinDate: '',
            invoiceCode: '',
            invoiceNumber: '',
            invoiceStatus: '0',
            // invoiceType: '',
            managerStatus: '1',
            checkStatus: scope.activeTab == '1' ? '0' : '10',
            checkFlag: '1',
          },
        }
        if (scope.selStatus == 'noSel') {
          scope.param.param.checkStatus = scope.activeTab == '1' ? '0' : '10'
          scope.param.param.authStatus = '255'
        } else {
          scope.param.param.checkStatus = '10'
          scope.param.param.authStatus = scope.activeTab == '1' ? '0,255' : '0'
        }
        // setDateTime(scope.res)
      }

      // 分页
      scope.totalItems = 0 // 组件初始化设置总页数
      scope.param.pageSize = 10
      scope.param.pageNum = 1

      scope.pageChanged = () => {
        // 点击页码
        qrySelecInfo()
      }

      scope.orderMap = {
        sortKey: '',
        sortVal: '',
      }
      scope.selectedHandle = function selectedHandle() {
        scope.param.orderMap = {}
        if (scope.orderMap.sortKey)
          scope.param.orderMap[scope.orderMap.sortKey] = scope.orderMap.sortVal
        qrySelecInfo()
      }

      httpRequest.get_getIsDrawbackEnterprises().then((res) => {
        if (res.data.success) {
          httpRequest
            .get_qryOrgTaxPeriod(
              JSON.parse(localStorage.user_info).user.currentOrgId
            )
            .then((res) => {
              if (res.data.success) {
                scope.res = res
                scope.periodName = res.data.value.periodName
                scope.drawbackExpireTime = res.data.value.drawbackExpireTime
                scope.periodCode = res.data.value.periodCode
                const expireTimeArr = scope.drawbackExpireTime.split('-')
                scope.drawbackExpireTime = `${expireTimeArr[0]}年${expireTimeArr[1]}月${expireTimeArr[2]}日`
                // setDateTime(res)
                qrySelecInfo()
              }
            })
        } else {
          logger.logError(res.data.message)
        }
      })
      function enumCodeExchangeName(arr, code) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i]['enumCode'] === '' + code) {
            return arr[i]['enumName']
          }
        }
      }

      function selInitParam(checked, isCancel, selectList) {
        const reqArr = selectList ? selectList : scope.selectedRows
        let reqStr = ''
        const checkInvoices = []
        let totalAmt = 0
        let totalTaxamt = 0
        const reqArrLen = reqArr.length
        let selFlag = true
        let invoiceStatusFlag = true
        let managerStatusFlag = true
        let invoiceStatusAbnormalInfo = []
        let managerStatusAbnormalInfo = []
        for (let i = 0; i < reqArr.length; i++) {
          checkInvoices.push({
            invoiceId: reqArr[i].invoiceAccountId,
          })
          totalAmt += reqArr[i].totalAmt
          totalTaxamt += reqArr[i].totalTaxamt
          reqArr[i].invoiceDate = reqArr[i].invoiceDate.substring(0, 10)
          reqStr += `${reqArr[i].invoiceCode}=${reqArr[i].invoiceNumber}=${
            reqArr[i].invoiceDate
          }=${isCancel ? 0 : 2}=0;`
          if (checked == 10 && reqArr[i].checkStatus != 0) {
            selFlag = false
          }
          if (checked == 0 && reqArr[i].authStatus == 0) selFlag = false
          // 发票状态
          if (reqArr[i].invoiceStatus != 0) {
            invoiceStatusFlag = false
            invoiceStatusAbnormalInfo.push({
              invoiceCode: reqArr[i].invoiceCode,
              invoiceNumber: reqArr[i].invoiceNumber,
              enumCode: reqArr[i].invoiceStatus,
            })
          }
          // 管理状态
          if (reqArr[i].managerStatus == 0) {
            managerStatusFlag = false
            managerStatusAbnormalInfo.push({
              invoiceCode: reqArr[i].invoiceCode,
              invoiceNumber: reqArr[i].invoiceNumber,
            })
          }
        }
        reqStr = reqStr.substring(0, reqStr.length - 1)
        const b = modalSelConDetailService.Base64()
        reqStr = b.encode(reqStr)
        const resolveObj = {
          reqStr,
          reqArrLen,
          totalAmt,
          totalTaxamt,
          checked,
          // idArr,
          checkInvoices,
          periodCode: scope.periodCode,
          checkType: 1,
          applyType: scope.activeTab == '1' ? '' : '0',
        }
        const res = {
          resolveObj,
          selFlag,
          invoiceStatusFlag,
          managerStatusFlag,
          invoiceStatusAbnormalInfo,
          managerStatusAbnormalInfo,
        }
        return res
      }

      scope.selectionModal = function (selectList) {
        const res = selInitParam(10, false, selectList)
        const resolveObj = res.resolveObj
        const selFlag = res.selFlag
        const invoiceStatusFlag = res.invoiceStatusFlag
        const managerStatusFlag = res.managerStatusFlag
        const invoiceStatusAbnormalInfo = res.invoiceStatusAbnormalInfo
        const managerStatusAbnormalInfo = res.managerStatusAbnormalInfo
        resolveObj.activeTab = scope.activeTab
        $uibModal.open({
          template: modalSureSelConfirm,
          controller: modalSureSelConCtrl,
          backdrop: 'static',
          openedClass: 'mod-modal mod-modal-lg',
          resolve: {
            items1() {
              return resolveObj
            },
          },
          scope,
        })
        return
        if (
          resolveObj.reqArrLen > 0 &&
          selFlag &&
          invoiceStatusFlag &&
          managerStatusFlag
        ) {
          $uibModal.open({
            template: modalSureSelConfirm,
            controller: modalSureSelConCtrl,
            backdrop: 'static',
            openedClass: 'mod-modal mod-modal-lg',
            resolve: {
              items1() {
                return resolveObj
              },
            },
            scope,
          })
        } else {
          let msg = ''
          if (!resolveObj.reqArrLen) {
            msg = '请至少选择一条未勾选的发票数据！'
          }
          if (!selFlag) {
            msg = '您选择的发票中包含已勾选的发票，不能重复勾选！'
          }
          if (!invoiceStatusFlag) {
            msg = '退税勾选失败，原因如下：<br>'
            for (let i in invoiceStatusAbnormalInfo) {
              msg += `发票代码：${
                invoiceStatusAbnormalInfo[i]['invoiceCode']
              }  号码：${
                invoiceStatusAbnormalInfo[i]['invoiceNumber']
              }    原因：发票状态为${enumCodeExchangeName(
                scope.dictionary.ivat_invoice_status,
                invoiceStatusAbnormalInfo[i]['enumCode']
              )}<br>`
            }
          }
          if (!managerStatusFlag) {
            if (!msg) {
              msg = '退税勾选失败，原因如下：<br>'
            }
            for (let i in managerStatusAbnormalInfo) {
              msg += `发票代码：${managerStatusAbnormalInfo[i]['invoiceCode']}  号码：${managerStatusAbnormalInfo[i]['invoiceNumber']}    原因：管理状态为非正常<br>`
            }
          }

          msg = `<div class="layer-msg-content">
                            <div class="content-left"><i class="icon iconfont icon-error iconfont-error"></i></div>
                            <div class="content-center">
                                提示
                                <div class="message-content">${msg}</div>
                            </div>
                        </div>`
          layer.open({
            type: 0,
            title: false,
            resize: false,
            closeBtn: 0,
            btn: ['确定'],
            shadeClose: false,
            skin: 'layer-message-self',
            content: msg,
            area: ['540px', ''],
            yes: function (index, layero) {
              layer.close(index)
            },
          })
        }
      }
      scope.cancelSelModal = () => {
        const res = selInitParam(0, true)
        const resolveObj = res.resolveObj
        const selFlag = res.selFlag
        resolveObj.activeTab = scope.activeTab
        if (resolveObj.reqArrLen > 0 && selFlag) {
          $uibModal.open({
            template: modalCancelSuccess,
            controller: modalCancelSuccessCtrl,
            backdrop: 'static',
            // windowClass: "modalSelConDetail",
            openedClass: 'mod-modal mod-modal-lg',
            resolve: {
              items2() {
                return resolveObj
              },
            },
            scope,
          })
        } else {
          let msg = ''
          if (!resolveObj.reqArrLen) {
            msg = '请至少选择一条已勾选的发票数据！'
          }
          if (!selFlag) {
            msg = '只可取消未确认的退税发票！'
          }
          logger.logMsg({
            title: '确认提交',
            icon: 'error',
            message: msg,
          })
        }
      }
      scope.confirmModal = () => {
        const resolveObj = {
          periodCode: scope.periodCode,
          checked: scope.param.param.checkStatus,
        }
        $uibModal.open({
          template: modalConfirmSuccess,
          controller: modalConfirmConCtrl,
          backdrop: 'static',
          openedClass: 'mod-modal mod-modal-lg',
          resolve: {
            items1() {
              return resolveObj
            },
          },
          scope,
        })
      }
      scope.checkeConfig = [
        {
          enumTypeCode: 'check_status',
          enumName: '未勾选',
          enumCode: '0',
        },
        {
          enumTypeCode: 'check_status',
          enumName: '已勾选',
          enumCode: '10',
        },
      ]

      // scope.$watch('$parent.activeSel', (newV) => {
      //     if (newV != 3) {
      //         getAmt()
      //     }
      // })

      // 错误弹框
      const importErrorModal = function importErrorModal(modalData) {
        const modalInstance = $uibModal.open({
          templateUrl: 'importError.html',
          controller: [
            '$scope',
            '$uibModalInstance',
            'logger',
            'items1',
            function ($scope, $uibModalInstance, logger, items1) {
              $scope.modalData = items1
              $scope.list = items1.data.list
              function handleListData(data) {
                const obj = JSON.parse(data.rowContent)
                data.invoiceCode = obj.invoiceCode
                data.invoiceNumber = obj.invoiceNumber
              }
              $scope.list.forEach((item) => {
                handleListData(item)
              })
              $scope.pageOptions = {
                // 分页器
                totalItems: $scope.modalData.data.total,
                currentPage: ++$scope.modalData.data.prePage,
                maxSize: $scope.modalData.data.pageSize,
              }
              function queryList() {
                httpRequest
                  .post_getPageDlBatchInfoList({
                    pageNum: $scope.pageOptions.currentPage,
                    pageSize: $scope.pageOptions.maxSize,
                    param: $scope.modalData.batchNo,
                  })
                  .then((res) => {
                    $scope.list = res.data.value.list
                    $scope.list.forEach((item) => {
                      handleListData(item)
                    })
                    $scope.pageOptions = {
                      // 分页器
                      totalItems: res.data.value.total,
                      currentPage: ++res.data.value.prePage,
                      maxSize: res.data.value.pageSize,
                    }
                  })
              }

              $scope.pageChanged = () => {
                queryList()
              }
              $scope.ok = () => {
                $uibModalInstance.close()
              }
            },
          ],
          backdrop: 'static',
          openedClass: 'mod-modal-importexcel',
          windowClass: 'mod-modal mod-modal-lg',
          bindToController: true,
          resolve: {
            items1() {
              return modalData
            },
          },
        })
        modalInstance.result.then(
          () => {},
          () => {}
        )
      }
      // 确认弹框
      const importConfirmModal = function importConfirmModal(modalData) {
        const modalInstance = $uibModal.open({
          templateUrl: 'importConfirm.html',
          controller: [
            '$scope',
            '$uibModalInstance',
            'logger',
            'items1',
            function ($scope, $uibModalInstance, logger, items1) {
              $scope.modalData = items1
              $scope.dictData = items1.dictData
              $scope.list = items1.data.list
              $scope.pageOptions = {
                // 分页器
                totalItems: $scope.modalData.data.total,
                currentPage: ++$scope.modalData.data.prePage,
                maxSize: $scope.modalData.data.pageSize,
              }

              function queryList() {
                httpRequest
                  .post_qryDlBatchInfoSuc({
                    pageNum: $scope.pageOptions.currentPage,
                    pageSize: $scope.pageOptions.maxSize,
                    param: $scope.modalData.batchNo,
                  })
                  .then((res) => {
                    $scope.list = res.data.value.list
                    $scope.pageOptions = {
                      // 分页器
                      totalItems: res.data.value.total,
                      currentPage: ++res.data.value.prePage,
                      maxSize: res.data.value.pageSize,
                    }
                  })
              }

              $scope.pageChanged = () => {
                queryList()
              }

              let allList = []

              function getAllList(pageNum, pageSize, param, qryLoading) {
                httpRequest
                  .post_qryDlBatchInfoSuc({
                    pageNum,
                    pageSize,
                    param,
                  })
                  .then(
                    (res) => {
                      allList = allList.concat(res.data.value.list)
                      if (allList.length != res.data.value.total) {
                        getAllList(pageNum + 1, pageSize, param, qryLoading)
                      } else {
                        $uibModalInstance.close(allList, qryLoading)
                      }
                    },
                    () => {
                      logger.logError('查询数据出错')
                    }
                  )
              }
              $scope.ok = () => {
                const qryLoading = layer.msg('正在处理，请您耐心等待···', {
                  time: 0,
                  skin: 'layer-loading-self',
                  icon: 16,
                  shade: 0.5,
                })
                getAllList(1, 20, $scope.modalData.batchNo, qryLoading)
                // $uibModalInstance.close()
              }
              $scope.cancel = () => {
                $uibModalInstance.dismiss()
              }
            },
          ],
          backdrop: 'static',
          openedClass: 'mod-modal-importexcel',
          windowClass: 'mod-modal modal-deduction-import-confirm',
          bindToController: true,
          resolve: {
            items1() {
              return modalData
            },
          },
        })
        modalInstance.result.then(
          (allList, qryLoading) => {
            // 勾选
            layer.close(qryLoading ? qryLoading : layer.index)
            allList && allList.length && scope.selectionModal(allList)
          },
          () => {}
        )
      }
      // 批量导入
      scope.uploadFiles = function uploadFiles(file, errFiles) {
        if (file == null && errFiles.length >= 1) {
          logger.logError(
            '文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入'
          )
          return
        }
        if (file) {
          file.upload = Upload.upload({
            url: `${host.etcloudIvatApp}dl/dlTaskService/importBill`,
            data: {
              importFile: file,
              typeCode,
            },
          })
          // 文件上传
          // loading动画
          const importinglayer = layer.msg('玩命上传中，请耐心等待', {
            time: 0,
            skin: 'layer-loading-self',
            icon: 16,
            shade: 0.5,
          })
          file.upload.then(
            (res) => {
              $timeout(() => {
                if (!res.data.success) {
                  layer.close(importinglayer)
                  return logger.logError(res.data.message || '上传失败')
                }
                if (res.data.value.sourceCount === 0) {
                  layer.close(importinglayer)
                  return logger.logTips('导入数据为空！', 'warn')
                }
                const { batchNo, sourceCount, errorCount } = res.data.value
                // 有错误数据，查询错误信息，错误弹框
                if (res.data.value.errorCount > 0) {
                  httpRequest
                    .post_getPageDlBatchInfoList({
                      pageNum: 1,
                      pageSize: 10,
                      param: res.data.value.batchNo,
                    })
                    .then((res1) => {
                      layer.close(importinglayer)
                      importErrorModal({
                        batchNo,
                        sourceCount,
                        successCount: sourceCount - errorCount,
                        errorCount,
                        data: res1.data.value,
                        activeTab: scope.activeTab,
                      })
                    })
                }
                // 无错误，查询正常发票，确认弹框
                if (res.data.value.errorCount === 0) {
                  // if(res.data.value.errorCount > 0) {
                  httpRequest
                    .post_qryDlBatchInfoSuc({
                      pageNum: 1,
                      pageSize: 10,
                      param: res.data.value.batchNo,
                    })
                    .then((res1) => {
                      layer.close(importinglayer)
                      importConfirmModal({
                        batchNo,
                        sourceCount,
                        successCount: sourceCount - errorCount,
                        errorCount,
                        data: res1.data.value,
                        activeTab: scope.activeTab,
                        dictData: scope.dictData,
                      })
                    })
                }
              })
            },
            (response) => {
              if (response.status > 0) {
                layer.close(importinglayer)
                logger.logError('上传失败')
              }
            }
          )
        }
      }
      // 模板下载
      scope.downloadExcel = function downloadExcel() {
        window.open(
          `${
            host.etcloudIvatApp
          }dl/dlTaskService/export_${typeCode}?accessToken=${localStorage.getItem(
            'id_token'
          )}`
        )
      }
    },
  }
}

drawBack.$inject = [
  '$uibModal',
  'httpRequest',
  'logger',
  'modalSelConDetailService',
  'operationService',
  '$timeout',
  'Upload',
]



// WEBPACK FOOTER //
// ./src/components/drawBack/drawBack.js